// extracted by mini-css-extract-plugin
export default {"resendCode":"resendCode--REaYm","disabled":"disabled--_SOTH"};